module.exports = __webpack_public_path__ + "images/innovationfarm_44b04072f6a50c83120e03df678bed44.jpg";